import React from "react";
import Button from "../../toolkit/ButtonV1";
import BarChartIcon from "../../icons/BarChartIcon";
import baseTheme from "../../themes/baseTheme";
import Menu from "@mui/material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  Typography,
  Box,
  createTheme,
  Stack
} from "@mui/material";

import "../../Localization/i18n";
import { useTranslation } from "react-i18next";
import Status from "../../stories/StatusComponent/StatusComponent";
import GetfVDateFormate from "../../utils/Genaricfunctions";
import { useNavigate } from "react-router-dom";
import { getOrgType } from "../../utils/Token";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export default function VendorListItem({ status, headers = [], statusRoleMap, ...props }) {
  const { palette } = baseTheme;
  const theme = createTheme({});
  const padding = "16px 24px";
  const { t } = useTranslation();

  const navigate = useNavigate();
  const ViewFinancialAnalytics = () => {
    navigate("/ClientAndAdminViewFinancialAnalytics?pqid=" + props.prequalificationId + "&clientid=" + props.clientId + "&vendorId=" + props.vendorId + "&vname=" + props?.vendorName + "&ID=1");
  }

  return (
    <>
      <Box
        display="flex"
        padding={padding}
        borderBottom="solid 1px"
        borderColor={palette.grey[30]}
        alignItems="center"
      >
        <Box width={headers.find((h) => h.id === "vendorName")}>
          <Typography variant="body2">
            <a
              variant="body2"
              style={{ textDecoration: "none", color: "#2A93DB" }}
              href={"/vendordetails?pqid=" + props.prequalificationId + "&ClientId=" + props?.ClientId}
            >
              {props.vendorName}
            </a>
            <Box >
              <Typography variant="body1">{props.templateCode}</Typography>
            </Box>
          </Typography>
        </Box>
        <Box width={headers.find((h) => h.id === "status")}>
          <Status typeStatus={props.Status} ChangePq={true} />
        </Box>
        <Box width={headers.find((h) => h.id === "statusPeriod")}>
          <Typography variant="body2">
            {GetfVDateFormate(props.prequalificationStart)}&thinsp;to&thinsp;
            {GetfVDateFormate(props.prequalificationFinish)}
          </Typography>
        </Box>

        <Box width={headers.find((h) => h.id === "analytics")} hidden={getOrgType() === "Client"}>
          <Button
            label="Financial Analytics"
            leadingComponent={<BarChartIcon />}
            role="linkBlue"
            sx={{ alignItems: "baseline" }}
            onClick={ViewFinancialAnalytics}
          />
        </Box>

        <Box width={headers.find((h) => h.id === "icon")}>
          <Tooltip title={"User rating (" + props.userRating + ") is less than Threshold Limit "} placement="top" arrow>
            <InfoOutlinedIcon
              hidden={props?.isVendorRatingBelowThresholdLimit !== true}
              sx={{
                color: "#cc0000",
                fontSize: 23
              }}
            />
          </Tooltip>
        </Box>

      </Box>
    </>
  );
}
